import { Alert, Typography } from '@branch-messenger/willow-ui'
import styled from 'styled-components'

export const StyledAlert = styled(Alert).attrs({
  $type: 'secondary',
})`
  padding: ${({ theme }) => theme.space[6]};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[4]};
  background-color: ${({ theme }) => theme.colors.background};
`

export const AlertBodyText = styled(Typography).attrs({ $size: 'xs' })``
